import baseConfig from '../config';

// Try to load local config, use empty objects if not found
let local_base = {};
let local_frontend = {};

try {
  // Use Vite's import.meta.glob to synchronously import the local config
  // The { eager: true } option ensures the module is loaded synchronously
  const localConfigModules = import.meta.glob(['../config.local.ts', '/config.local.ts'], { eager: true });

  // Try both possible paths for the config
  const possiblePaths = ['../config.local.ts', '/config.local.ts'];
  let localConfigModule;

  // Check each path
  for (const path of possiblePaths) {
    if (localConfigModules[path]) {
      localConfigModule = localConfigModules[path];
      console.log(`[config] Found local config at ${path}`);
      break;
    }
  }

  // Apply the local config if found
  if (localConfigModule) {
    local_base = ((localConfigModule as any).config_local || {}).config_base || {};
    local_frontend = ((localConfigModule as any).config_local || {}).config_frontend || {};
    //console.log('[config] Local config found', { local_base, local_frontend });
  } else {
    //console.log('[config] No local config found, using default config');
  }
} catch (error) {
  //console.log('[config] No local config found, using empty config');
}

const config_demo = {
  // Demo-specific overrides if needed
};

const config_test = {
  // Test-specific frontend overrides (per-env service URLs live in ../config.ts)
};

const config_prod = {
  // Production-specific frontend overrides (per-env service URLs live in ../config.ts)
};

// Initialize config with all settings except local ones
const frontendConfig = {
  ...baseConfig,

  // Firebase config (using Vite's import.meta.env)
  firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  firebaseAppId: import.meta.env.VITE_FIREBASE_APP_ID || '',
  firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
  firebaseMeasurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '', // Optional
  firebaseMessagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  firebaseStorageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
  firebaseProjectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',

  // Sentry config (using Vite's import.meta.env)
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',
  sentryOrg: import.meta.env.VITE_SENTRY_ORG || '', // Used by Sentry Vite plugin, also good to have here for consistency if needed
  sentryProject: import.meta.env.VITE_SENTRY_PROJECT || '', // Used by Sentry Vite plugin

  // GraphQL Admin Secret (if needed by codegen for schema introspection)
  graphqlSecret: import.meta.env.VITE_HASURA_ADMIN_SECRET || '', // Or VITE_GRAPHQL_ADMIN_SECRET


  // Google config
  googleApiKey: import.meta.env.VITE_GOOGLE_API_KEY || '',
  googleMapsKey: import.meta.env.VITE_GOOGLE_API_KEY || '',
  googlePlacesKey: import.meta.env.VITE_GOOGLE_PLACES_KEY || '',

  // Auth0 config
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',

  // Stream Chat config
  streamChatApiKey: import.meta.env.VITE_STREAM_API_KEY || '',
  streamChatApiSecret: import.meta.env.VITE_STREAM_API_SECRET || '',

  // Accessorial codes
  accessorialCodes: 'delay,fuel,partial,waived,surge,tow,toll,ride,platform,roadside,insurance,reimbursement',

  // Environment specific keys
  ...config_test, //opinionated default to test
  ...(baseConfig.appEnv === 'demo' ? config_demo : null),
  ...(baseConfig.appEnv === 'test' ? config_test : null),
  ...(baseConfig.appEnv === 'prod' ? config_prod : null),

  // Local must always be last to ensure it overrides all other configs
  ...local_base,
  ...local_frontend,
};

// console.log(
//   `[config.frontend.ts] Composed frontendConfig. AppEnv: ${frontendConfig.appEnv}, GQL_URL: ${frontendConfig.graphqlHttpUrl}`,
//   frontendConfig
// );

export default frontendConfig;
